import _ from 'lodash'

const isDev = false

export default class Api {
    static get(url, filters) {
        return new Promise(function (resolve, reject) {
            // Prepare Request
            var headers = new Headers()
            headers.append('X-WP-Nonce', wpApiSettings.nonce)

            var options = {
                method: 'GET',
                headers: headers,
                mode: 'cors',
                cache: 'default',
            }

            // Prepare URL
            let apiUrl = new URL(kpc_loc.endpoint + url)

            // Filters
            let apiFilters = {}
            if (!_.isEmpty(filters)) {
                if (!_.isEmpty(filters.orderBy)) {
                    apiFilters.orderBy = filters.orderBy
                }
                if (!_.isEmpty(filters.orderWay)) {
                    apiFilters.orderWay = filters.orderWay
                }
                if (_.isInteger(filters.pageCurrent)) {
                    apiFilters.pageCurrent = filters.pageCurrent
                }
                if (_.isInteger(filters.pageLimit)) {
                    apiFilters.pageLimit = filters.pageLimit
                }
                if (!_.isEmpty(filters.searchVal)) {
                    apiFilters.searchVal = filters.searchVal
                }
                if (!_.isEmpty(filters.searchLang)) {
                    apiFilters.searchLang = filters.searchLang
                }
                if (!_.isEmpty(apiFilters)) {
                    apiUrl.search = new URLSearchParams(apiFilters).toString()
                }
            }

            // Log for DEBUG
            if (isDev) {
                console.log('API.get : ' + url, apiFilters)
            }

            // Fetch
            fetch(apiUrl, options)
                .then((response) => {
                    return response.json()
                })
                .then((result) => {
                    if (isDev) {
                        console.log('API.get - Success : ' + url, result)
                    }
                    resolve(result)
                })
                .catch((error) => {
                    if (isDev) {
                        console.log('API.get - Error : ' + url, error)
                    }
                    reject(error)
                })
        })
    }

    static post(url, data) {
        return new Promise(function (resolve, reject) {
            // Prepare Request
            var headers = new Headers()
            headers.append('X-WP-Nonce', wpApiSettings.nonce)
            headers.append('Content-Type', 'application/json')

            let body = JSON.stringify(data)

            var options = {
                method: 'POST',
                headers: headers,
                mode: 'cors',
                cache: 'default',
                body: body,
            }

            if (isDev) {
                console.log('API.post : ' + url, body)
            }

            // Fetch
            fetch(kpc_loc.endpoint + url, options)
                .then((response) => {
                    return response.json()
                })
                .then((result) => {
                    if (result.status != 'DONE') {
                        reject(result)
                    } else {
                        if (isDev) {
                            console.log('API.get - Success : ' + url, result)
                        }
                        resolve(result)
                    }
                })
                .catch((error) => {
                    if (isDev) {
                        console.log('API.post - Error : ' + url, error)
                    }
                    reject(error)
                })
        })
    }
}
